import Rete from 'rete'

import RcnSingleTemplate from './RcnSingleTemplate'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'
import lingualName from '../../const/lingualName'
import { lang } from '../../assets/lang'

export default class RcnSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.RCN_SINGLE)
    
    this.data.component = RcnSingleTemplate
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.RCN_SINGLE
    this.setConnection()
    
    const rcnSingleInput = new Rete.Input(CONST_SOCKET.RCN_SINGLE_INPUT, lang.Rcn_single_socket_input_reply, this.socket.rcnSingleInput, false)
    const rcnSingleOutput = new Rete.Output(CONST_SOCKET.RCN_SINGLE_OUTPUT, lang.Rcn_single_socket_output_next, this.socket.rcnSingleOutput, false)
    
    node.addInput(rcnSingleInput)
    node.addOutput(rcnSingleOutput)
    
    if (this.isSequenceAddonAvailable) {
      const rcnSingleOutputSequence = new Rete.Output(
        CONST_SOCKET.RCN_SINGLE_OUTPUT_SEQUENCE, 
        lang.Rcn_single_socket_output_next_sequence, 
        this.socket.rcnSingleOutputSequence, 
        false
      )

      node.addOutput(rcnSingleOutputSequence)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    // outputs[CONST_SOCKET.RCN_SINGLE_OUTPUT] = node.data
  }

  setConnection() {
    
    this.socket.rcnSingleOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.rcnSingleOutput.combineWith(this.socket.openaiInput)
    this.socket.rcnSingleOutput.combineWith(this.socket.carouselInput)
    this.socket.rcnSingleOutput.combineWith(this.socket.imageInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.rcnSingleOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.rcnSingleOutput.combineWith(this.socket.videoInput)
      this.socket.rcnSingleOutput.combineWith(this.socket.audioInput)
      this.socket.rcnSingleOutput.combineWith(this.socket.fileInput)
      // this.socket.rcnSingleOutput.combineWith(this.socket.otnInput)
      if(this.isRcnAddonAvailable)
        this.socket.rcnSingleOutput.combineWith(this.socket.rcnInput)
    }

    this.socket.rcnSingleOutput.combineWith(this.socket.ecommerceInput)
    this.socket.rcnSingleOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.rcnSingleOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.rcnSingleOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.rcnSingleOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output: Sequence
    if (this.isSequenceAddonAvailable) {
      this.socket.rcnSingleOutputSequence.combineWith(this.socket.sequenceInput)    
    }
    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.rcnSingleOutput.combineWith(this.socket.conditionInput)
    }

  }
}